<button
  class="tw-btn-secondary-filled"
  #privacyButton
  [cdkMenuTriggerFor]="context_menu"
  [attr.aria-label]="
    translate('VISIBILITY SETTINGS', 'Core_privacyMenuPopupHeader')
  "
  [attr.aria-description]="
    translate(
      'Choose who can see your self-rating level. Current value: ' +
        selected().label,
      'Core_privacyMenuPopupAriaDescription',
      {
        privacy: selected().label,
      }
    )
  "
>
  @if (selected()) {
    <da-icon [icon]="selected().icon" class="tw-size-4 tw-text-neutral-800">
    </da-icon>
    {{ selected().label }}
  }
</button>
<ng-template #context_menu>
  <!-- Loading Indicator -->
  <div
    class="tw-mt-1 tw-h-[184px] tw-min-h-40 tw-w-[296px] tw-min-w-40 tw-rounded-xl tw-bg-white tw-p-3 tw-shadow-sm"
    cdkMenu
    #menu="cdkMenu"
  >
    <div>
      <h1 class="tw-text-base tw-font-extrabold tw-text-neutral-800">
        {{ translate('VISIBILITY SETTINGS', 'Core_privacyMenuPopupHeader') }}
      </h1>
      <div class="tw-py-1 tw-text-xs tw-text-neutral-600">
        {{
          translate(
            'Choose who can see your self-rating level.',
            'Core_privacyMenuPopupDescription'
          )
        }}
      </div>
    </div>
    <ul class="tw-w-full" role="listbox">
      @for (option of privacyOptions; track option) {
        <li
          class="tw-inline-flex tw-h-14 tw-w-full tw-cursor-pointer hover:tw-bg-neutral-100"
          cdkMenuItem
          (cdkMenuItemTriggered)="handleSelect(option)"
        >
          <div class="tw-m-auto tw-my-auto tw-mr-3 tw-size-4">
            <da-icon [icon]="option.icon" class="tw-size-4 tw-text-neutral-600">
            </da-icon>
          </div>

          <div class="tw-flex tw-flex-grow tw-flex-col tw-py-1">
            <div
              class="tw-text-base"
              [class]="
                option.privacyId === selectedPrivacy()
                  ? 'tw-font-extrabold tw-text-neutral-900'
                  : 'tw-text-neutral-800'
              "
            >
              {{ option.label }}
            </div>
            <div
              class="tw-text-xs tw-text-neutral-800"
              [class]="{
                'tw-font-semibold': option.privacyId === selectedPrivacy(),
              }"
            >
              {{ option.description }}
            </div>
          </div>
          @if (option.privacyId === selectedPrivacy()) {
            <div
              class="tw-m-auto tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded-full tw-bg-green-600 tw-text-white"
            >
              <da-icon
                icon="check"
                className="tw-size-3 tw-mt-1"
                [solidSize]="16"
                type="solid"
              ></da-icon>
            </div>
          }
        </li>
      }
    </ul>
  </div>
</ng-template>
